<template>
    <div class="tos">
        <div class="signup-tos">
            <input type="checkbox" id="signupTosChecked" name="signupTosChecked" v-model="accepted" @change="emit">
            <p>Hyväksyn palvelun <a @click="openTos">käyttöehdot</a></p>
        </div>
        <div>
            <modal
                name="signup-tos"
                @before-open="fetchTos"
                :adaptive="true"
                :scrollable="true"
                :reset="true"
                width="60%"
                height="auto"
            >
                <div class="modal__content">
                    <div class="tos" v-html="signupTosContent"></div>
                    <div class="modal__footer">
                        <span @click="rejectTos">En hyväksy</span>
                        <button class="btn btn--call-to-action btn--small" v-on:click.stop="acceptTos">
                            OK
                        </button>
                    </div>
                </div>

            </modal>
        </div>
    </div>
</template>

<script>
    import ApiCall from '../modules/ApiCall';
    import Routes from '../modules/Routes';

    export default {
        model: {
            prop: 'accepted',
            event: 'change'
        },
        props: {
            country: {
                type: String,
                default: 'fi'
            },
            language: {
                type: String,
                default: 'fi'
            },
            locale: {
                type: String,
                default: 'fi'
            }
        },
        data() {
            return {
                accepted: false,
                signupTosState: 'closed',
                signupTosContent: null
            };
        },
        methods: {
            emit() {
                this.$emit('change', this.accepted);
            },
            fetchTos() {
                if (!this.signupTosContent) {
                    ApiCall.getData(
                        Routes.generate('_public_signup_tos', {
                            locale: this.locale,
                            terms: 'signup',
                            language: this.language,
                            country: this.country
                        })
                    ).then((data) => {
                        this.signupTosContent = data;
                    });
                }
            },
            openTos() {
                this.tosState = 'open';
                this.$modal.show('signup-tos');
                this.$ga.event('Signup TOS', 'Opened');
                gtag('event', 'open_signup_tos');
            },
            acceptTos(e) {
                e.preventDefault();
                this.tosState = 'closed';
                this.$modal.hide('signup-tos');
                this.accepted = true;
                this.emit();
                this.$ga.event('Signup TOS', 'Accepted');
                gtag('event', 'accept_signup_tos');
                return false;
            },
            rejectTos() {
                this.tosState = 'closed';
                this.$modal.hide('signup-tos');
                this.accepted = false;
                this.emit();
                this.$ga.event('Signup TOS', 'Rejected');
                gtag('event', 'reject_signup_tos');
                return false;
            },
        }
    };
</script>
